import { Injectable } from '@angular/core';
import $ from 'jquery';
import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { isFirefox, isEdge } from '../../../../shared/utils/browser.util';

import { Container, ContentColumn } from 'src/app/shared/model/container.models';
import { ContentBlockType, Modalconfig } from 'src/app/shared/constants';
import { ContentRow } from 'src/app/company/templates/conversation-templates/shared/models/conversationModels';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';

import * as _ from 'lodash';
import getFindDeep from 'deepdash/getFindDeep';

// deepdash is unmaintained and its .d.ts types the lodash arg as `Object`, which TS 5.8
// (Angular 20) rejects because lodash's `toString(value)` is incompatible with Object's. The
// runtime call is correct; cast around the bad upstream type.
const findDeep = getFindDeep(_ as any);

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  public isFireFox = isFirefox();
  public isEdge = isEdge();
  confirmationModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  constructor(
    private modalService: BsModalService
  ) { }

  clearVerticalClasses = () => {
    $('.top-hover').removeClass('top-hover');
    $('.bottom-hover').removeClass('bottom-hover');
  }

  clearHorizontalClasses = () => {
    $('.right-hover').removeClass('right-hover');
    $('.left-hover').removeClass('left-hover');
  }
  clearAllBorderClasses = () => {
    this.clearVerticalClasses();
    this.clearHorizontalClasses();
  }

  getUiBorders = (ui, t) => {
    const height = t.height() ? t.height() : 55;  // TODO: patch remove it.
    const width = t.width() ? t.width() : 55; // TODO: patch remove it.
    ui.topBorder = ui.offset.top;
    ui.leftBorder = ui.offset.left;
    ui.bottomBorder = (ui.topBorder + height);
    ui.rightBorder = (ui.leftBorder + width);
    return ui;
  }
  getElementBorders = (e) => {
    e.topBorder = e.offset().top;
    e.bottomBorder = e.offset().top + e.height();
    e.leftBorder = e.offset().left;
    e.rightBorder = e.offset().left + e.width();
    return e;
  }

  applyBorderClass = (e, bClass) => {
    this.clearAllBorderClasses();
    e.addClass(bClass);
  }
  isAtTop = (e, ui) => {
    return ui.topBorder <= e.topBorder && e.topBorder <= ui.bottomBorder;
  }
  isAtBottom = (e, ui) => {
    return ui.topBorder - 10 <= e.bottomBorder && e.bottomBorder <= ui.bottomBorder;
  }
  isAtLeft = (e, ui) => {
    return ui.leftBorder <= e.leftBorder && e.leftBorder <= ui.rightBorder;
  }
  isAtRight = (e, ui) => {
    return ui.leftBorder <= e.rightBorder && e.rightBorder <= ui.rightBorder;
  }
  handleTopHover = (e, ui, contentRow?) => {
    if (((contentRow && !e.parents('.row:visible').length) || !contentRow)
      && !(e.parent('.custom-col').parent('.tab-parent-div ').length && contentRow)) {
      if (e.hasClass('col')) {
        const ec = e.children('.row:visible').first();
        if (ec.length) {
          e = ec;
        }
      }
      this.applyBorderClass(e, 'top-hover');
    }
  }
  handleBottomHover = (e, ui, contentRow?) => {
    if (((contentRow && !e.parents('.row:visible').length) || !contentRow)
      && !(e.parent('.custom-col').parent('.tab-parent-div ').length && contentRow)) {
      if (e.hasClass('col')) {
        const ec = e.children('.row:visible').last();
        if (ec.length) {
          e = ec;
        }
      }
      if (e.parent('.col:visible').children('.row:visible').last()[0] == e[0]) {
        this.applyBorderClass(e, 'bottom-hover');
      }
    }
  }
  handleLeftHover = (e, ui) => {
    let contSel = 'article.content-box';
    if (e.parent('.custom-col').parent('.tab-parent-div ').length) {
      contSel = 'div.tab-parent-div';
    }
    if ((this.isFireFox || this.isEdge) && e.hasClass('row')
      && e.parents('.col:visible').parents(contSel).length
      && !e.children('.col:visible').length
      && e.parents('.row:visible').children('.dndDraggableDisabled').children('.col:visible').length < 5) {
      this.applyBorderClass(e, 'left-hover');
    } else if ((!this.isFireFox && !this.isEdge) && e.hasClass('row')
      && e.parent('.col:visible').parent(contSel).length
      && !e.children('.dndDraggableDisabled').children('.col:visible').length) {
      this.applyBorderClass(e, 'left-hover');
    } else if (e.hasClass('row')
      && e.parents('.col:visible').parents('.row:visible').parents('.col:visible').parents(contSel).length) {
      e = e.parent('.col:visible');
      if (e.parents('.row:visible').children('.dndDraggableDisabled').children('.col:visible').length < 5) {
        this.applyBorderClass(e, 'left-hover');
      }
    }
  }
  handleRightHover = (e, ui) => {
    let contSel = 'article.content-box';
    if (e.parent('.custom-col').parent('.tab-parent-div ').length) {
      contSel = 'div.tab-parent-div';
    }
    if ((this.isFireFox || this.isEdge) && e.hasClass('row')
      && e.parents('.col:visible').parents(contSel).length
      && !e.children('.col:visible').length
      && e.parents('.row:visible').children('.dndDraggableDisabled').children('.col:visible').length < 5) {
      this.applyBorderClass(e, 'right-hover');
    } else if ((!this.isFireFox && !this.isEdge) && e.hasClass('row')
      && e.parent('.col:visible').parent(contSel).length
      && !e.children('.dndDraggableDisabled').children('.col:visible').length) {
      this.applyBorderClass(e, 'right-hover');
    } else if (e.hasClass('row')
      && e.parents('.col:visible').parents('.row:visible').parents('.col:visible').parents(contSel).length) {
      e = e.parent('.col:visible');
      if (e.parents('.row:visible').children('.dndDraggableDisabled').children('.col:visible').length < 5
        && e[0] == e.parents('.row:visible').children('.dndDraggableDisabled').first().children('.col:visible').last()[0]) {
        this.applyBorderClass(e, 'right-hover');
      }
    }
  }
  detectAndAddHoverClass = (e, ui, t, isRowMoved?) => {
    const elem = t.find('.editor-content-block');
    ui = this.getUiBorders(ui, elem);
    e = this.getElementBorders(e);
    if (elem.hasClass('conversation-template')) {
      if (this.isAtTop(e, ui)) {
        this.handleTopHover(e, ui);
      } else if (this.isAtBottom(e, ui)) {
        this.handleBottomHover(e, ui);
      }
    } else {
      if (this.isAtTop(e, ui)) {
        this.handleTopHover(e, ui);
      } else if (this.isAtBottom(e, ui)) {
        this.handleBottomHover(e, ui);
      }
      else if (this.isAtLeft(e, ui)) {
        this.handleLeftHover(e, ui);
      } else if (this.isAtRight(e, ui)) {
        this.handleRightHover(e, ui);
      }
    }
  }

  getPositionClass = (e) => {
    if (e.hasClass('top-hover')) {
      return 'top';
    } else if (e.hasClass('bottom-hover')) {
      return 'bottom';
    } else if (e.hasClass('left-hover')) {
      return 'left';
    } else if (e.hasClass('right-hover')) {
      return 'right';
    } else {
      return null;
    }
  }

  getClosestHoverClass = (e) => {
    if (e.hasClass('col')) {
      const rt = e.children('.row.top-hover');
      if (rt.length) {
        return 'top';
      } else {
        const rb = e.children('.row.bottom-hover');
        if (rb.length) {
          return 'bottom';
        }
      }
      return this.getPositionClass(e);
    } else if (e.hasClass('row')) {
      let cl = e.parent('.col.left-hover');
      if (cl.length) {
        return 'left';
      } else {
        const cr = e.parent('.col.right-hover');
        if (cr.length) {
          return 'right';
        } else {
          cl = e.parent('.col').next('.left-hover');
          if (cl.length) {
            return 'right';
          } else {
            // not on this row, get the closest row and determine this row's location
            let c = e.next('.row.top-hover');
            if (c.length) {
              // the next has the top class, so it is below the current element
              return 'bottom';
            } else {
              c = e.prev('.row.bottom-hover');
              if (c.length) {
                // the row above has the bottom class, so return top
                // this may be an edge/non-existent case
                return 'top';
              }
            }
          }
        }
      }
    }
  }

  getCorrectPosition = (e) => {
    const positionClass = this.getPositionClass(e);
    return positionClass ? positionClass : this.getClosestHoverClass(e);
  }

  getElementId = (e) => {
    if (e.length) {
      if (e.hasClass('col')) {
        return e.attr('id').replace('column-', '');
      } else {
        return e.attr('id').replace('row-', '');
      }
    }
  }

  // {{{ scrollElementToBottom
  scrollElementToBottom = (e) => {
    const h = e[0].scrollHeight;
    e.animate({
      scrollTop: h + 'px'
    }, 300);
  }

  scrollElementToRight = (e) => {
    const w = e[0].scrollWidth;
    e.animate({
      scrollLeft: w + 'px'
    }, 300);
  }

  resetAllContainments = (t, gridWidth) => {
    t.cols = null;
    t.cols = t.parent('.row').children('.col-handle');
    _.each(t.cols, (item) => {
      const c = $(item);
      this.resetContainment(c, gridWidth);
    });
  }

  resetContainment = (t, gridWidth, interval?) => {
    if (t) {
      const p = t.prev('.col');
      const n = t.next('.col');
      const pr = t.parent('.row');

      if (p.length && n.length) {

        // get the full width
        const fw = pr.width();
        // get 10% of the full width
        const pc = Math.floor(fw * .1);
        // get the point to the left of the segment
        const l = p.offset().left + pc - (pc * .4);
        // get the point to the right of the segment
        const r = n.offset().left + n.width() - pc + (pc * .4);
        // set boundries
        t.draggable('option', 'containment', [l, 1, r, 1]);
      }
    }
  }

  getNumberOfCols = (t, pass) => {
    // begin with parent column
    if (t) {
      t.rows = t.children('.row');
      t.colCount = 0;
      t.hRowCount = 0;
      t.hRowOrder = 0;
      if (pass > 0 && t.rows.length) {
        t.colCount = -1;
      }
      // find out which row has the most cols and mark it
      _.each(t.rows, (ritem) => {
        const r: any = $(ritem);
        r.cols = r.children('.col');
        if (r.cols.length > t.hRowCount) {
          t.hRowOrder++;
          ritem.hRowOrder = t.hRowOrder;
          t.hRowCount = r.cols.length;
        } else {
          ritem.hRowOrder = 0;
        }
      });
      // loop through rows
      _.each(t.rows, (ritem) => {
        const r: any = $(ritem);
        // get row's columns
        r.cols = r.children('.col');
        // get the hightest column count in all rows
        if (ritem.hRowOrder == t.hRowOrder) {
          t.hRowCount = r.cols.length;
          t.colCount = t.colCount + r.cols.length;
          if (r.cols.length) {
            // loop through row's columns
            _.each(r.cols, (item) => {
              const c = $(item);
              t.colCount = t.colCount + this.getNumberOfCols(c, pass + 1);
            });
          }
        }
      });
    }
    return t.colCount;
  }

  getPercentFromOffset = (off, fullWidth) => {
    return Math.round(Math.round((off / fullWidth) * 100) / 10) * 10;
  }

  resizeCols = (e, ui, gridWidth) => {
    // establish handle
    const t = $(e.target);
    // establish the left col
    const prev = t.prev();
    // establish the right col
    const next = t.next();
    // establish the parent row
    const p: any = t.parent('.row');
    // get the count of the columns in the left col
    p.colCount = p.children('.col').length;

    const fullWidth = p.width();
    const off = (t.offset().left - p.offset().left);

    const handlePerc = this.getPercentFromOffset(off, fullWidth);
    let nextPerc = Math.floor((((next.offset().left - p.offset().left) + next.width()) / fullWidth) * 100) - handlePerc;
    if (nextPerc < 0) { nextPerc = nextPerc * -1; }
    let prevPerc = Math.floor(((prev.offset().left - p.offset().left) / fullWidth) * 100) - handlePerc;
    if (prevPerc < 0) { prevPerc = prevPerc * -1; }

    this.setGClass(prev, prevPerc);
    this.setGClass(next, nextPerc);
  }

  setGClass = (t, num) => {
    if (!isNaN(num) && num) {
      t[0].className = t[0].className.replace(/\bgrid-.[0-9]*?\b/g, '');
      t.addClass('grid-' + num);
    }
  }

  getClosestGridLetiable = (t) => {
    const fullWidth = t.parent('.row').width();
    const posPerc = ((t.position().left / fullWidth) * 100);
    const posLet = Math.round(posPerc / 10) * 10;
    return fullWidth * (posLet / 100);
  }
  moveToClosestCorrectPosition = (e) => {
    const t = $(e.target);
    t.css({
      left: this.getClosestGridLetiable(t) + 'px'
    });
  }

  checkTypes = (type, currentTabData, movedData, position) => {
    if ((type === ContentBlockType.Tabs && currentTabData)
      || ((type === ContentBlockType.MoveContent && movedData && movedData.isRowMoving) &&
        (currentTabData || position === 'left' || position === 'right'))) {
      this.showAlert('You cannot add this type of content to this area.');
      this.clearAllBorderClasses();
      return false;
    } else {
      return true;
    }
  }
  pasteCheckTypes = (contType, type) => {
    if (contType === ContentBlockType.CopyPaste
      && (contType === ContentBlockType.Tabs
        || (contType === ContentBlockType.CopyPaste && type.rowCopied))) {
      this.showAlert('You cannot add this type of content to this area.');
      this.clearAllBorderClasses();
      return false;
    } else {
      return true;
    }
  }
  checkTopBottom(type, rowColumnData, movedData, pastedContent) {
    if (((type === ContentBlockType.MoveContent && movedData && movedData.isRowMoving)
      || (type === ContentBlockType.CopyPaste && pastedContent && pastedContent.isCopyExist && pastedContent.rowCopied))
      && (rowColumnData && rowColumnData.columnData.contentRowId)) {
      this.showAlert('You cannot add this type of content to this area.');
      this.clearAllBorderClasses();
      return false;
    } else {
      return true;
    }
  }

  showAlert(msg: string) {
    const initialState = {
      msg,
      showCancelBtn: false
    };
    this.confirmationModalRef = this.modalService.show(ConfirmationModelComponent,
      Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
    this.confModalSubsciber = this.confirmationModalRef.content.onclose.subscribe((toClear: boolean) => {
      this.confirmationModalRef.hide();
      this.confModalSubsciber.unsubscribe();
    });
  }

  getAllRowColumnData(row, rowId) {
    let rowColumnData = {
      columnData: null,
      rowData: null
    };
    _.some(row.contentRows, (eachColumnData) => {
      if (eachColumnData.id == rowId) {
        rowColumnData = {
          columnData: row,
          rowData: eachColumnData
        };
        return true;
      }
    });
    if (!(rowColumnData.columnData && rowColumnData.rowData)) {
      _.some(row.contentRows, (eachColumnData) => {
        rowColumnData = this.getColumnRowData(eachColumnData, rowId);
        if (rowColumnData.columnData && rowColumnData.rowData) {
          return true;
        }
      });
    }
    return rowColumnData;
  }
  getColumnRowData(row, rowId) {
    let rowColumnData = {
      columnData: null,
      rowData: null
    };
    if (row.contentColumns) {
      _.some(row.contentColumns, (eachColumnData) => {
        rowColumnData = this.getAllRowColumnData(eachColumnData, rowId);
        if (rowColumnData.columnData && rowColumnData.rowData) {
          return true;
        }
      });
    }
    return rowColumnData;
  }

  getRowDataById(row, rowId) {
    let rowData;
    _.some(row, (eachRowData) => {
      if (eachRowData.id == rowId) {
        rowData = eachRowData;
        return true;
      }
    });
    return rowData || null;
  }

  getCurrentPageData(containerData, currentPageId): Container {

    const currentSelectedPageData = findDeep(containerData, (value, key, parent) => {
      if (value.id == currentPageId) {
        return value;
      }
    }, { childrenPath: 'containers' as any });

    return currentSelectedPageData ? currentSelectedPageData.value : null;
  }

  getCurrentSectionData(containerData, sectionId) {
    let currentContainerData = null;
    _.some(containerData.containers, (eachConatinerData) => {
      if (eachConatinerData.id == sectionId) {
        currentContainerData = eachConatinerData;
        return true;
      }
    });
    return currentContainerData;
  }

  getAllLeftRightRowColumnData(row, rowId) {
    let rowColumnData = {
      columnData: null,
      rowData: null
    };
    if (!(rowColumnData.columnData && rowColumnData.rowData)) {
      _.some(row.contentRows, (eachColumnData) => {
        rowColumnData = this.getLeftRightColumnRowData(eachColumnData, rowId);
        if (rowColumnData.columnData && rowColumnData.rowData) {
          return true;
        }
      });
    }
    return rowColumnData;
  }
  getLeftRightColumnRowData(row, rowId) {
    let rowColumnData = {
      columnData: null,
      rowData: null
    };
    _.some(row.contentColumns, (eachColumnData) => {
      if (eachColumnData.id == rowId) {
        rowColumnData = {
          columnData: eachColumnData,
          rowData: eachColumnData.contentRows[0]
        };
        return true;
      }
    });
    if (!(rowColumnData.columnData && rowColumnData.rowData)) {
      _.some(row.contentColumns, (eachColumnData) => {
        rowColumnData = this.getAllLeftRightRowColumnData(eachColumnData, rowId);
        if (rowColumnData.columnData && rowColumnData.rowData) {
          return true;
        }
      });
    }
    return rowColumnData;
  }


  getAddedColumnData(containerData, columnId: number, sectionId: number) {
    const sectionIndex = _.findIndex(containerData, (eachContainter) => eachContainter['id'] == +sectionId);
    let columnIndex;
    if (sectionIndex !== -1) {
      columnIndex = _.findIndex(containerData[sectionIndex].contentColumns[0].contentRows, (eachContentColumn) =>
        eachContentColumn['id'] == +columnId);
    }
    return { sectionIndex, columnIndex };
  }
  getPageFromPlaybook(id: number, playbook) {
    let pageDetails: any = {};
    _.each(playbook.containers, (incontent) => {
      if (incontent.id === id && !pageDetails.id) {
        pageDetails = _.cloneDeep(incontent);
        return pageDetails;
      }
      if (incontent.containers && incontent.containers.length && !pageDetails.id) {
        _.each(incontent.containers, (cont) => {
          if (cont.id === id) {
            pageDetails = _.cloneDeep(cont);
            return pageDetails;
          }
        });
        pageDetails = this.getPageFromPlaybook(id, incontent);
      }
    });
    return pageDetails;
  }

  getTabsRowColumnId(contentRows, rowId: number) {
    let rowIndexData = {
      firstRowIndex: null,
      firstColumnIndex: null,
      secondRowIndex: null
    };
    _.some(contentRows, (eachContentRow, index) => {
      if (eachContentRow.id === rowId) {
        rowIndexData.firstRowIndex = index;
        return true;
      }
    });
    if (rowIndexData.firstRowIndex === null) {
      _.some(contentRows, (eachContentRow: ContentRow, firstRowindex: number) => {
        const innerData = this.getTabsColumnIndex(eachContentRow, rowId);
        if (innerData.secondRowIndex != null) {
          rowIndexData = {
            ...innerData,
            firstRowIndex: firstRowindex
          };
          return true;
        }
      });
    }
    return { ...rowIndexData };
  }
  getTabsColumnIndex(eachContentRow: ContentRow, rowId: number) {
    const innerIndexData = {
      firstColumnIndex: null,
      secondRowIndex: null
    };
    _.some(eachContentRow.contentColumns, (eachContentColumn: ContentColumn, index: number) => {
      const isExist = _.some(eachContentColumn.contentRows, (eachInnerRows, innerIndex: number) => {
        if (eachInnerRows.id === rowId) {
          innerIndexData.firstColumnIndex = index;
          innerIndexData.secondRowIndex = innerIndex;
          return true;
        }
      });
      return isExist;
    });
    return innerIndexData;
  }

  getTabsBlockIndex(tabBlockId: number, tabsContentColumn: Array<ContentColumn>) {
    const tabBlockIndex = {
      columnIndex: null,
      rowIndex: null
    };
    _.some(tabsContentColumn, (eachTabsContentColumn, columnIndex) => {
      const isTabBlockFound = _.some(eachTabsContentColumn.contentRows, (eachTabsContentRow, rowIndex) => {
        if (!eachTabsContentRow.contentColumns.length && eachTabsContentRow.contentBlock.tabsBlock_Id === tabBlockId) {
          tabBlockIndex.columnIndex = columnIndex;
          tabBlockIndex.rowIndex = rowIndex;
          return true;
        }
      });
      return isTabBlockFound;
    });
    return { ...tabBlockIndex };
  }

  getRowIdFromContentBlockId(contentColumns: ContentColumn, currentRowId: number, contentBlockId: number) {
    let contentRowId: number;
    const currentRowData: ContentRow = this.getRowDataById(contentColumns.contentRows, currentRowId);
    _.some(currentRowData.contentColumns, (eachContentColumns: ContentColumn) => {
      if (eachContentColumns.contentRows[0].contentBlock.id === contentBlockId) {
        contentRowId = eachContentColumns.contentRows[0].contentBlock.contentRowId;
        return true;
      }
    });
    return contentRowId;
  }
}
